import React from 'react';
import axios from 'axios';
import get from 'lodash/get';
import { withFormik } from 'formik';

import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';
import Text from '@lightspeed/cirrus-text';

const SyncCategoriesModal = ({ handleSubmit, isSubmitting, onClose }) => (
  <Modal className="cirrus" isOpen onRequestClose={() => onClose()}>
    <ModalHeader onCloseClicked={() => onClose()}>Erase &amp; reset eCom Categories</ModalHeader>
    <ModalBody>
      <Text body color="gray">
        Are you sure you want to <strong>Erase &amp; reset eCom Categories?</strong>
      </Text>
    </ModalBody>
    <ModalFooter>
      <Group className="cr-justify-end">
        <Button onClick={() => onClose()}>No, don&#39;t do it</Button>
        <Button variant="secondary" fill loading={isSubmitting} onClick={handleSubmit}>
          Yes, do it
        </Button>
      </Group>
    </ModalFooter>
  </Modal>
);

const enhancedSyncCategoriesModal = withFormik({
  handleSubmit: async (values, formikBag) => {
    formikBag.setSubmitting(true);

    const { accountId } = formikBag.props;

    try {
      await axios.post(`/staff/accounts/${accountId}/ecom/resync-categories`);
      formikBag.props.onConfirm({ message: 'Sync Categories pushed to Queue' });
    } catch (e) {
      window.alertUser(get(e, 'response.data.errors[0].detail') || 'An error occurred');
    }

    formikBag.setSubmitting(false);
    formikBag.props.onClose();
  },
})(SyncCategoriesModal);

export default enhancedSyncCategoriesModal;
